export default "__VITE_ASSET__BKGVMwR___"